export const CHANNEL_SETTINGS_QUERY_KEY = 'channelSettings';
